// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportTitle.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import SimpleInputConfiguration from './Izenda.SimpleInputConfiguration';
import { REPORT_PART_MODE as MODE } from 'logic/data/Izenda.ReportBodyConstants';
import classnames from 'classnames';
import connect from 'share/enhancers/Izenda.Connect';

@connect()
export default class ReportPartTitle extends Component {
  static propTypes = {
    mode: PropTypes.oneOf([MODE.CONFIG, MODE.PREVIEW]),
    reportPart: PropTypes.object
  };

  renderConfig() {
    const reportPart = this.props.reportPart;
    const localization = this.props.localization;
    const classes = classnames(this.props.className, 'report-part-title');

    return (
      <div className={classes}>
        <SimpleInputConfiguration
          reportPart={reportPart}
          dataKey="previewTitle"
          title={localization.getText('REPORTDESIGNER_LABEL_TITLE_SETTINGS')}
        />
        <SimpleInputConfiguration
          reportPart={reportPart}
          dataKey="description"
          title={localization.getText('REPORTDESIGNER_LABEL_DESCRIPTION_SETTINGS')}
        />
      </div>
    );
  }

  renderPreview() {
    const reportPart = this.props.reportPart;
    const title = getStyle('previewTitle');
    const description = getStyle('description');
    const classes = classnames(this.props.className, 'u_textBreak');

    return (
      <div className={classes}>
        <div style={title.gridStyle}>
          <span style={title.spanStyle}>{getHeaderInfo('previewTitle')}</span>
        </div>
        <div style={description.gridStyle}>
          <span style={description.spanStyle}>{getHeaderInfo('description')}</span>
        </div>
      </div>
    );

    function getHeaderInfo(key) {
      const re = reportPart.getDataValueByKey && reportPart.getDataValueByKey(key);
      return re && re.text;
    }

    function getStyle(key) {
      const settings = (reportPart[key] && reportPart[key].settings) || {};
      const font = settings.font || {};
      const alignment = settings.alignment && settings.alignment.alignment;

      const style = {
        fontFamily: font.family,
        fontSize: `${font.size}px`,
        fontWeight: font.bold ? 'bold' : 'normal',
        textAlign: alignment || 'none',
        textDecoration: font.underline ? 'underline' : 'none',
        fontStyle: font.italic ? 'italic' : 'normal',
        color: font.color
      };

      return {
        gridStyle: style,
        spanStyle: {
          backgroundColor: font.highlightColor
        }
      };
    }
  }

  render() {
    return this.props.mode === MODE.CONFIG ? this.renderConfig() : this.renderPreview();
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.ReportPartTitle.js